export const toCamelCase = (str) => {
  const text = str.toLowerCase();
  return text.split(" ").reduce((s, c) => s
    + (c.charAt(0).toUpperCase() + c.slice(1)));
};
